module.exports = __webpack_public_path__ + "img/cgjz-1.45ada1dd.jpg";